import { __assign, __awaiter, __decorate, __extends, __generator } from "tslib";
import React from 'react';
import { Gapped } from '@skbkontur/react-ui/components/Gapped';
import { Button } from '@skbkontur/react-ui/components/Button';
import { Tooltip } from '@skbkontur/react-ui/components/Tooltip';
import { Input } from '@skbkontur/react-ui/components/Input';
import { Textarea } from '@skbkontur/react-ui/components/Textarea';
import { locale } from '@skbkontur/react-ui/lib/locale/decorators';
import { FiasLocaleHelper } from '../locale';
import { FiasExtraFields, FiasFields, FiasFormValidation, FiasDivision, } from '../types';
import { FiasAddressElement } from '../models/FiasAddressElement';
import { FiasSearch } from '../FiasSearch/FiasSearch';
import { FiasAddress } from '../models/FiasAddress';
import { FiasCountrySelector } from './FiasCountrySelector';
import { jsStyles } from './FiasForm.styles';
import { FiasComboBox } from './FiasComboBox';
import { RadioGroup, Radio } from '@skbkontur/react-ui';
import { Fias } from '..';
import { FiasAPI } from '../api/FiasAPI';
var FiasForm = /** @class */ (function (_super) {
    __extends(FiasForm, _super);
    function FiasForm(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            address: _this.props.address,
            division: _this.props.api.division,
        };
        _this.lastVerifyPromise = null;
        _this.submit = function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, address, division;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.lastVerifyPromise];
                    case 1:
                        _b.sent();
                        _a = this.state, address = _a.address, division = _a.division;
                        return [2 /*return*/, {
                                address: address,
                                division: division,
                            }];
                }
            });
        }); };
        _this.reset = function (_a) {
            var address = _a.address, division = _a.division;
            _this.setState({
                address: address,
                division: division,
            }, _this.validate);
        };
        _this.getCommonFieldProps = function (field) { return ({
            error: _this.isFieldWithError(field),
            warning: _this.isFieldWithWarning(field),
            placeholder: _this.locale[field + "Placeholder"],
        }); };
        _this.isFieldWithError = function (field) {
            var address = _this.state.address;
            var validationLevel = _this.props.validationLevel;
            return address.hasError(field) && validationLevel === FiasFormValidation.Error;
        };
        _this.isFieldWithWarning = function (field) {
            var address = _this.state.address;
            var validationLevel = _this.props.validationLevel;
            return address.hasError(field) && validationLevel === FiasFormValidation.Warning;
        };
        _this.renderFields = function (fields) {
            return fields.map(function (field) {
                var control = _this.fields[field];
                var settings = _this.fieldsSettings[field];
                if (control && Boolean(settings && settings.visible)) {
                    var meta = control.meta, render = control.render;
                    var label = _this.locale[field + "Label"];
                    return (control && (React.createElement(FiasForm_1.Field, { label: label, key: field, "data-tid": "fias-field-" + field },
                        React.createElement(Tooltip, { pos: 'right middle', render: meta.tooltip, useWrapper: true }, render()))));
                }
            });
        };
        _this.renderAddressComboBox = function (field, width) {
            if (width === void 0) { width = '100%'; }
            var comboboxField = _this.fields[field];
            if (comboboxField && FiasForm_1.isComboboxMeta(comboboxField.meta)) {
                var address = _this.state.address;
                var _a = comboboxField.meta, props = _a.props, createRef = _a.createRef;
                var commonProps = _this.getCommonFieldProps(field);
                return (React.createElement(FiasComboBox, __assign({}, commonProps, props, { value: address, width: width, drawArrow: false, searchOnFocus: false, limit: _this.props.limit, ref: createRef })));
            }
        };
        _this.renderPostalCodeInput = function () {
            var inputField = _this.fields[FiasExtraFields.postalcode];
            if (inputField && FiasForm_1.isInputMeta(inputField.meta)) {
                var address = _this.state.address;
                var _a = inputField.meta, props = _a.props, createRef = _a.createRef;
                var commonProps = _this.getCommonFieldProps(FiasExtraFields.postalcode);
                var value = address.postalCode;
                return React.createElement(Input, __assign({}, commonProps, props, { value: value, width: 130, ref: createRef }));
            }
        };
        _this.createAddressComboboxMeta = function (field) {
            return {
                ref: null,
                props: _this.createAddressComboBoxProps(field),
                tooltip: _this.createAddressComboBoxTooltip(field),
                createRef: function (ref) {
                    var comboboxField = _this.fields[field];
                    if (comboboxField) {
                        comboboxField.meta.ref = ref;
                    }
                },
            };
        };
        _this.createPostalCodeInputMeta = function () {
            return {
                ref: null,
                props: _this.createPostalCodeInputProps(),
                tooltip: function () { return _this.createPostalCodeTooltip(); },
                createRef: function (ref) {
                    var inputField = _this.fields[FiasExtraFields.postalcode];
                    if (inputField) {
                        inputField.meta.ref = ref;
                    }
                },
            };
        };
        _this.createAddressComboBoxProps = function (field) {
            var getItems = function (searchText) { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                return [2 /*return*/, this.createItemsSource(searchText, field)];
            }); }); };
            var onValueChange = function (value) {
                var address = _this.state.address;
                var newFields = __assign(__assign({}, address.fields), value.fields);
                // get rid of undefineds
                var addressField;
                for (addressField in newFields) {
                    if (!newFields[addressField]) {
                        delete newFields[addressField];
                    }
                }
                _this.handleAddressChange(FiasAddress.createFromAddress(address, { fields: newFields }), _this.validate);
            };
            var onInputValueChange = function () {
                _this.resetAddressErrors();
            };
            var onUnexpectedInput = function (query) {
                var _a;
                var address = _this.state.address;
                var newFields = __assign(__assign({}, address.fields), (_a = {}, _a[field] = query ? new FiasAddressElement(field, query) : undefined, _a));
                return FiasAddress.createFromAddress(address, { fields: newFields });
            };
            var renderItem = function (address) {
                var element = address.fields[field];
                if (!element) {
                    return address.getText();
                }
                if (field === FiasFields.region && element.data) {
                    var regionCode = element.data.code.substr(0, 2);
                    return regionCode + " " + element.getText();
                }
                var diffAddress = new FiasAddress({
                    fields: _this.state.address.getDiffFields(address, _this.fieldsSettings),
                });
                var hasParentFields = Boolean(diffAddress.getClosestParentFiasId(field));
                return hasParentFields ? diffAddress.getText() : element.getText(element.isTypeMatchField(field));
            };
            var renderValue = function (address) {
                var element = address.fields[field];
                return element && element.getText(element.isTypeMatchField(field));
            };
            var renderNotFound = function () {
                var address = _this.state.address;
                var messages = [_this.locale[field + "NotFound"] || _this.locale.addressNotFound];
                if (address.isAllowedToFill(field)) {
                    if (address.hasOnlyIndirectParent(field)) {
                        messages.push(_this.locale.addressFillParentOrSearch);
                    }
                }
                else {
                    messages = _this.locale[field + "FillBefore"]
                        ? [_this.locale[field + "FillBefore"]]
                        : messages;
                }
                return (React.createElement("div", null, messages.map(function (message, i, m) { return (React.createElement("div", { key: i }, message + (m[i + 1] ? '.' : ''))); })));
            };
            var valueToString = function (address) {
                var element = address.fields[field];
                return element ? element.editableString : '';
            };
            var itemToValue = valueToString;
            return {
                getItems: getItems,
                onValueChange: onValueChange,
                onInputValueChange: onInputValueChange,
                onUnexpectedInput: onUnexpectedInput,
                renderItem: renderItem,
                renderValue: renderValue,
                itemToValue: itemToValue,
                valueToString: valueToString,
                renderNotFound: renderNotFound,
            };
        };
        _this.createItemsSource = function (searchText, field) { return __awaiter(_this, void 0, void 0, function () {
            var _a, address, division, limit, schema, options;
            return __generator(this, function (_b) {
                _a = this.state, address = _a.address, division = _a.division;
                limit = this.props.limit || FiasForm_1.defaultProps.limit;
                schema = this.api.schema;
                if (address.isAllowedToFill(field)) {
                    options = {
                        searchText: searchText,
                        field: field,
                        parentFiasId: address.getClosestParentFiasId(field),
                        fullAddress: address.isAllowedToSearchFullAddress(field),
                        directParent: address.isAllowedToSearchFieldOnlyInClosestFilledParent(field, this.fieldsSettings, {
                            division: division,
                            schema: schema,
                        }),
                        limit: limit + 1,
                    };
                    return [2 /*return*/, this.api.search(options).then(function (result) {
                            var success = result.success, data = result.data, error = result.error;
                            return success && data
                                ? Promise.resolve(data.map(function (item) {
                                    return FiasAddress.createFromResponse(item);
                                }))
                                : Promise.reject(error);
                        })];
                }
                return [2 /*return*/, Promise.resolve([])];
            });
        }); };
        _this.getFieldTooltipContent = function (field) {
            var address = _this.state.address;
            if (_this.isFieldWithError(field) || _this.isFieldWithWarning(field)) {
                return address.getError(field);
            }
            return null;
        };
        _this.createAddressComboBoxTooltip = function (field) { return function () {
            var tooltipContent = _this.getFieldTooltipContent(field);
            var comboboxField = _this.fields[field];
            if (comboboxField && FiasForm_1.isComboboxMeta(comboboxField.meta)) {
                var combobox = comboboxField.meta.ref;
                var hasItems = combobox ? combobox.hasItems : false;
                return tooltipContent !== null && hasItems ? _this.locale.addressSelectItemFromList : tooltipContent;
            }
            return tooltipContent;
        }; };
        _this.createPostalCodeTooltip = function () {
            var tooltipContent = _this.getFieldTooltipContent(FiasExtraFields.postalcode);
            var replacePostalCode = function () {
                var address = _this.state.address;
                var additionalFields = __assign({}, address.additionalFields);
                delete additionalFields[FiasExtraFields.postalcode];
                _this.handleAddressChange(FiasAddress.createFromAddress(address, { additionalFields: additionalFields }), _this.validate);
            };
            return (tooltipContent && (React.createElement("div", null,
                React.createElement("span", null, tooltipContent),
                _this.state.address.isPostalCodeAltered && (React.createElement("div", null,
                    React.createElement(Button, { onClick: replacePostalCode, use: "link" }, _this.locale.postalcodeReplace))))));
        };
        _this.verify = function () {
            var address = _this.state.address;
            return _this.api.verify(address).then(function (result) {
                var success = result.success, data = result.data;
                if (success && data) {
                    return FiasAddress.verify(address, data);
                }
                return FiasAddress.removeFiasData(address);
            });
        };
        _this.handleDivisionChange = function (division) {
            var _a, _b;
            _this.setState({ address: new FiasAddress(), division: division }, _this.validate);
            (_b = (_a = _this.props).onDivisionChange) === null || _b === void 0 ? void 0 : _b.call(_a, division);
        };
        _this.handleCountryChange = function (country) {
            _this.handleAddressChange(FiasAddress.createFromAddress(_this.state.address, { country: country }));
        };
        _this.handleForeignAddressChange = function (value) {
            _this.handleAddressChange(FiasAddress.createFromAddress(_this.state.address, {
                foreignAddress: value,
            }));
        };
        _this.handleAddressChange = function (address, callback) {
            _this.setState({
                address: FiasAddress.createFromAddress(address, {
                    fields: FiasAddress.filterVisibleFields(address.fields, _this.fieldsSettings),
                }),
            }, callback);
        };
        _this.handleSearchChange = function (_a) {
            var fields = _a.fields;
            _this.handleAddressChange(FiasAddress.createFromAddress(_this.state.address, { fields: fields }), _this.validate);
        };
        _this.resetAddressErrors = function () {
            var address = _this.state.address;
            if (address.hasErrors) {
                _this.setState({
                    address: FiasAddress.createFromAddress(address, { errors: {} }),
                });
            }
        };
        _this.fields = FiasAddress.ALL_FIELDS.reduce(function (fields, field) {
            var _a, _b;
            switch (field) {
                case FiasExtraFields.postalcode:
                    return __assign(__assign({}, fields), (_a = {}, _a[field] = {
                        meta: _this.createPostalCodeInputMeta(),
                        render: function () { return _this.renderPostalCodeInput(); },
                    }, _a));
                default:
                    return __assign(__assign({}, fields), (_b = {}, _b[field] = {
                        meta: _this.createAddressComboboxMeta(field),
                        render: function () { return _this.renderAddressComboBox(field); },
                    }, _b));
            }
        }, {});
        return _this;
    }
    FiasForm_1 = FiasForm;
    Object.defineProperty(FiasForm.prototype, "isForeignForm", {
        get: function () {
            var address = this.state.address;
            var countrySelector = this.props.countrySelector;
            return address.isForeign || (Boolean(countrySelector) && !address.country);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FiasForm.prototype, "fieldsSettings", {
        get: function () {
            var _a = this.props, countrySelector = _a.countrySelector, userFieldsSettings = _a.userFieldsSettings;
            return Fias.getFieldsSettings({
                userFieldsSettings: userFieldsSettings,
                countrySelector: countrySelector,
                division: this.state.division,
                schema: this.api.schema,
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FiasForm.prototype, "api", {
        get: function () {
            var api = this.props.api;
            var division = this.state.division;
            if (api.division === division) {
                return api;
            }
            return FiasAPI.createFromAPI(api, { division: division });
        },
        enumerable: false,
        configurable: true
    });
    FiasForm.prototype.componentDidMount = function () {
        this.validate();
    };
    FiasForm.prototype.render = function () {
        var address = this.state.address;
        var _a = this.props, limit = _a.limit, countrySelector = _a.countrySelector, allowArbitraryCountry = _a.allowArbitraryCountry;
        var api = this.api;
        return (React.createElement("div", null,
            React.createElement(Gapped, { vertical: true },
                countrySelector && (React.createElement(FiasForm_1.Field, { label: this.locale.countryLabel, "data-tid": "fias-field-country" },
                    React.createElement(FiasCountrySelector, { api: api, country: address.country, onValueChange: this.handleCountryChange, limit: limit, allowArbitraryCountry: allowArbitraryCountry }))),
                this.props.divisionSelector && !this.isForeignForm && (React.createElement(FiasForm_1.Field, { "data-tid": "fias-field-division" },
                    React.createElement(RadioGroup, { value: this.state.division, onValueChange: this.handleDivisionChange },
                        React.createElement(Gapped, { gap: 16 },
                            React.createElement(Radio, { "data-tid": "fias-division-selector-municipal", value: FiasDivision.Municipal }, this.locale.divisionSelectorLabelMunicipal),
                            React.createElement(Radio, { "data-tid": "fias-division-selector-administrative", value: FiasDivision.Administrative }, this.locale.divisionSelectorLabelAdministrative))))),
                this.props.search && !this.isForeignForm && (React.createElement(FiasForm_1.Field, { "data-tid": "fias-field-search" },
                    React.createElement(FiasSearch, { api: api, address: address, onValueChange: this.handleSearchChange, limit: limit, placeholder: this.locale.searchPlaceholder }))),
                this.isForeignForm ? (React.createElement(Gapped, { vertical: true },
                    React.createElement(FiasForm_1.Field, { label: this.locale.foreignAddressLabel, "data-tid": "fias-field-foreignAddress" },
                        React.createElement(Textarea, { value: address.foreignAddress, onValueChange: this.handleForeignAddressChange, placeholder: this.locale.foreignAddressPlaceholder, width: "100%", resize: "none" })),
                    this.renderFields([FiasExtraFields.postalcode]))) : (this.renderFields(FiasAddress.ALL_FIELDS)))));
    };
    FiasForm.prototype.createPostalCodeInputProps = function () {
        var _this = this;
        return {
            onValueChange: function (value) {
                var _a;
                var address = _this.state.address;
                var newAdditionalFields = __assign(__assign({}, address.additionalFields), (_a = {}, _a[FiasExtraFields.postalcode] = value, _a));
                _this.handleAddressChange(FiasAddress.createFromAddress(address, {
                    additionalFields: newAdditionalFields,
                }), _this.validate);
            },
        };
    };
    FiasForm.prototype.validate = function () {
        var _this = this;
        var verifyPromise = (this.lastVerifyPromise = this.verify());
        verifyPromise.then(function (verifiedAddress) {
            if (verifyPromise === _this.lastVerifyPromise) {
                var addressUnknown = '';
                var validationLocale = _this.shouldValidateUnknownLevel()
                    ? __assign(__assign({}, _this.locale), { addressUnknown: addressUnknown }) : _this.locale;
                _this.setState({
                    address: FiasAddress.validate(verifiedAddress, validationLocale, _this.fieldsSettings),
                });
            }
        });
    };
    FiasForm.prototype.shouldValidateUnknownLevel = function () {
        return Boolean(this.api.suggestUnknownLevel || (this.api.suggestUnknownParts && 'House'));
    };
    var FiasForm_1;
    FiasForm.__KONTUR_REACT_UI__ = 'FiasForm';
    FiasForm.displayName = 'FiasForm';
    FiasForm.defaultProps = {
        validationLevel: 'Error',
        limit: 5,
        fieldsSettings: {},
        countrySelector: false,
    };
    FiasForm.Field = function (_a) {
        var dataTid = _a["data-tid"], label = _a.label, children = _a.children;
        return (React.createElement("div", { className: jsStyles.row(), "data-tid": dataTid },
            label && React.createElement("div", { className: jsStyles.label() }, label),
            React.createElement("div", { className: jsStyles.field() }, children)));
    };
    FiasForm.isComboboxMeta = function (meta) {
        var props = meta.props;
        return (Object.prototype.hasOwnProperty.call(props, 'onUnexpectedInput') &&
            Object.prototype.hasOwnProperty.call(props, 'getItems'));
    };
    FiasForm.isInputMeta = function (meta) {
        var props = meta.props;
        return !FiasForm_1.isComboboxMeta(meta) && Object.prototype.hasOwnProperty.call(props, 'onValueChange');
    };
    FiasForm = FiasForm_1 = __decorate([
        locale('Fias', FiasLocaleHelper)
    ], FiasForm);
    return FiasForm;
}(React.Component));
export { FiasForm };
